import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import pt from "./pt.json";

export default {
  en,
  es,
  fr,
  pt,
};
